import React from 'react';
import { Hero, Profiles } from '../components';
import * as ROUTES from '../constants/routes';
import logo from '../logo.svg';
export default function SelectProfileContainer({ user, setProfile }) {
  return (
    <>
      <Hero bg={false}>
        <Hero.Frame>
          <Hero.Logo to={ROUTES.HOME} src={logo} alt="Netflix" />
        </Hero.Frame>
      </Hero>

      <Profiles>
        <Profiles.Title>Who's watching ?</Profiles.Title>
        <Profiles.List>
          <Profiles.User
            onClick={() =>
              setProfile({
                displayName: user.displayName,
                photoURL: user.photoURL,
              })
            }
          >
            <Profiles.Picture src={user.photoURL} />
            <Profiles.Name>{user.displayName}</Profiles.Name>
          </Profiles.User>
        </Profiles.List>
      </Profiles>
    </>
  );
}
